import { Component, OnInit } from '@angular/core';
import { DataService } from 'app/data.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { ImagePreviewComponent } from 'app/components/image-preview/image-preview.component';
import { AuthService } from 'app/auth.service';

@Component({
  selector: 'app-verify-bank-payments',
  templateUrl: './verify-bank-payments.component.html',
  styleUrls: ['./verify-bank-payments.component.css']
})
export class VerifyBankPaymentsComponent implements OnInit {

  payments = []

  adPlans = []

  options = [
    {value: 'all', viewValue: 'All'},
    {value: 'true', viewValue: 'Verified'},
    {value: 'false', viewValue: 'Not Verified'}
  ]

  selectedOption = 'all'

  availablePayments = []

  constructor( private route: ActivatedRoute, private adminService: DataService, private notification: MatSnackBar, private dialog: MatDialog, private auth: AuthService) { }

  ngOnInit(): void {
    this.route.data.subscribe((data: { adPlans: any }) =>{
      this.adPlans = data.adPlans
    })
    this.adminService.getBankVouchers().subscribe(data => {
      let payments = data.bankPayments
      if(payments.length > 0){
        for(let payment of payments){
          payment['voucherPath'] = environment.api + '/images/' + payment['voucherPath']
          this.adminService.getProperty(payment.property_id).subscribe(data => {
            let adPlan = this.adPlans.find(adPlan => adPlan.id == data.propertyAd.ad_plan_id)
            if(adPlan){
              payment['plan'] = adPlan.plan
              payment['amount'] = adPlan.price
            }
            payment['previewLink'] = environment.url + '/property-preview/'+data.propertyAd.id+'?token='+this.auth.accessToken
            this.payments.push(payment)
          })
        }
        this.availablePayments = this.payments
      }
    })
  }

  verifyPayment(payment){
    payment.status = ! payment.status
    this.adminService.verifyBankVouchers(payment.id, payment.status).subscribe(data => {
      if(data.status){
        this.openNotification('Action has been completed!')
        if(payment.status){
          this.selectedOption = 'true'
        }else{
          this.selectedOption = 'false'
        }
      }
    }, error => {
      payment.status = ! payment.status
      if(error.error.message){
        this.openNotification(error.error.message)
      }
    })
  }

  filterPayments(){
    if(this.selectedOption == 'all'){
      this.availablePayments = this.payments
    }else if(this.selectedOption == 'true'){
      this.availablePayments = []
      for(let payment of this.payments){
        if(payment.status){
          this.availablePayments.push(payment)
        }
      }
    }else{
      this.availablePayments = []
      for(let payment of this.payments){
        if(payment.status == false){
          this.availablePayments.push(payment)
        }
      }
    }
  }

  openNotification(message){
    this.notification.open(message, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }

  imagePreview(src){
    this.dialog.open(ImagePreviewComponent, {
      maxWidth: '90%',
      maxHeight: '90%',
      data: {
        imageSource: src
      },
      panelClass: 'road-block'
    })
  }

}
